<template>
  <v-card flat>
    <!--    <v-card-title class="headline">-->
    <!--      Мастер-лицензии данного Объекта-->
    <!--      <v-spacer></v-spacer>-->
    <!--      <v-text-field-->
    <!--          v-if="masters"-->
    <!--          v-model="search"-->
    <!--          append-icon="mdi-magnify"-->
    <!--          label="Поиск"-->
    <!--          single-line-->
    <!--          hide-details-->
    <!--      ></v-text-field>-->
    <!--    </v-card-title>-->

    <div v-if="canOrderMaster" class="d-flex mx-3 mt-3">
      <v-spacer></v-spacer>
      <v-btn color="green" dark @click="orderMaster">
        Заказ мастер-лицензии
      </v-btn>
    </div>

    <v-data-table
      class="ma-3"
      :search="search"
      :headers="headers"
      :items="masters"
      :item-class="(item) => (item.isDeleted ? 'deleted' : '')"
      no-data-text="Пусто"
      no-results-text="Результатов нет"
      @click:row="editMaster"
      hide-default-footer
      :custom-sort="customSort"
      sort-by="id"
      :loading="tableLoading"
      loading-text="Загрузка"
      :items-per-page="10"
    >
      <template v-slot:item.expires="{ item }">
        <span :class="{ expired: new Date() > new Date(item.expires) }">{{
          new Date(item.expires).toLocaleDateString()
        }}</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <template v-if="$store.getters.user.roleId === 0">
          <v-tooltip v-if="!item.isDeleted" top nudge-bottom="4">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                @click.stop="deleteMasterConfirm(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Удалить</span>
          </v-tooltip>

          <v-tooltip v-else top nudge-bottom="4">
            <template v-slot:activator="{ on, attrs }">
              <v-icon @click.stop="restoreMaster(item)" v-bind="attrs" v-on="on">
                mdi-backup-restore
              </v-icon>
            </template>
            <span>Восстановить</span>
          </v-tooltip>
        </template>
      </template>
      <template v-slot:top="{ pagination, options, updateOptions }">
        <div
          class="d-flex justify-space-between align-center"
          style="border-bottom: thin solid rgba(0, 0, 0, 0.12)"
        >
          <v-text-field
            v-if="$store.getters.dealers"
            v-model="search"
            append-icon="mdi-magnify"
            label="Поиск"
            single-line
            hide-details
            class="pt-0 mt-0"
          ></v-text-field>

          <v-data-footer
            :pagination="pagination"
            :options="options"
            @update:options="updateOptions"
            :items-per-page-options="[10, 50, 100, -1]"
            items-per-page-text="$vuetify.dataTable.itemsPerPageText"
            style="border: none"
          />
        </div>
      </template>
      <template v-slot:item.updateTime="{ item }">
        <span>{{ formatUpdateTime(item.updateTime) }}</span>
      </template>
    </v-data-table>

    <confirmation-dialog
      ref="confirmation"
      title="Удаление Мастер-лицензии"
      agree-button="Удалить"
      disagree-button="Отмена"
      @agree="deleteMaster($event)"
    ></confirmation-dialog>
  </v-card>
</template>

<script>
import API from "@/axios/api";
import ConfirmationDialog from "@/components/ConfirmationDialog";

import FormatDateTime from "@/utils/time.js";

export default {
  components: {
    ConfirmationDialog,
  },
  props: ["objectId"],
  data() {
    return {
      deletingMasterId: "",

      tableLoading: true,
      search: "",
      masters: [],
      allHeaders: [
        {
          text: "#",
          align: "start",
          value: "id",
        },
        {
          text: "Модуль ПО",
          align: "start",
          value: "moduleName",
        },
        {
          text: "Фичи",
          align: "start",
          value: "features",
        },
        {
          text: "Max Date",
          align: "center",
          value: "expires",
        },
        {
          text: "Изменил",
          align: "center",
          value: "creatorName",
        },
        {
          text: "Дата последнего изменения",
          align: "start",
          value: "updateTime",
        },
        {
          text: "Действия",
          align: "center",
          value: "actions",
          sortable: false,
          superAdminOnly: true,
        },
      ],
    };
  },
  computed: {
    headers() {
      return this.allHeaders.filter(
        (h) => !h.superAdminOnly || this.$store.getters.user.roleId === 0
      );
    },
    canOrderMaster() {
      return this.$store.getters.user.roleId === 1;
    },
  },
  methods: {
    removeActionHeader() {
      if (this.$store.getters.user.roleId === 1) {
        this.headers = this.headers.filter(header => header.value !== "actions");
      }
    },
    customSort(items, index, isDesc) {
      if (index[0] === "expires") {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            return new Date(a.expires) > new Date(b.expires) ? 1 : -1;
          } else {
            return new Date(a.expires) > new Date(b.expires) ? -1 : 1;
          }
        });
      } else {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            return a[index[0]] > b[index[0]] ? 1 : -1;
          } else {
            return a[index[0]] > b[index[0]] ? -1 : 1;
          }
        });
      }
      return items;
    },
    editMaster(master) {
      if (master.isDeleted) {
        this.$store.commit("showSnackbar", {
          color: "warning",
          text: "Мастер-лицензия удалена",
        });
      } else {
        this.$router.push("/masters/" + master.id);
      }
    },
    orderMaster() {
      this.$router.push({ name: "MasterOrder", query: { object: this.objectId } });
    },
    deleteMasterConfirm(master) {
      this.deletingMasterId = master.id;
      this.$refs.confirmation.showDialog(
        master.id,
        `Вы действительно хотите удалить Мастер-лицензию на Модуль <span class="highlighted">${master.moduleName}</span> ?`
      );
    },
    deleteMaster(masterId) {
      API.get(`masters/${masterId}/delete`)
        .then((response) => {
          console.log(response.data);
          this.getObjectMasters();
          this.$store.dispatch("updateLicenses");
        })
        .catch((error) => {
          console.log(error);
          if (error.response.data.message)
            this.$store.commit("showSnackbar", {
              color: "error",
              text: error.response.data.message,
            });
        });
    },
    restoreMaster(master) {
      API.get(`masters/${master.id}/restore`)
        .then((response) => {
          console.log(response.data);
          this.getObjectMasters();
        })
        .catch((error) => {
          console.log(error);
          if (error.response.data.message)
            this.$store.commit("showSnackbar", {
              color: "error",
              text: error.response.data.message,
            });
        });
    },
    async getObjectMasters() {
      await API.get(`objects/${this.objectId}/masters`)
        .then((response) => {
          console.log(response.data);
          this.masters = response.data.masters;
          // this.masters.forEach(master => master.expires = new Date(master.expires).toLocaleDateString());
        })
        .catch((error) => {
          console.log(error);
        });
    },
    formatUpdateTime(time) {
      return FormatDateTime(time);
    },
  },
  created() {
    this.removeActionHeader();
    this.getObjectMasters().then(() => {
      this.tableLoading = false;
    });
  },
};
</script>

<style>
.expired {
  background-color: #eccdcd;
  color: #000000;
  padding: 0.2rem 0.5rem;
  border-radius: 3px;
}
</style>
